<template>
    <TaxSituationFormFields></TaxSituationFormFields>
</template>

<script setup lang="ts">
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { getNaturalWidgetFormValidationRules, initializeNaturalWidgetForm } from './forms'
import TaxSituationFormFields from './fields/TaxSituationFormFields.vue'

const { naturalProfile: account } = usePersonalAccountDataState()

initializeNaturalWidgetForm(getNaturalWidgetFormValidationRules('tax_situation'))
</script>
